export const LEGAUE_TABLES_REQUEST = 'LEGAUE_TABLES_REQUEST';
export const LEGAUE_TABLES_SUCCESS = 'LEGAUE_TABLES_SUCCESS';
export const LEGAUE_TABLES_FAIL = 'LEGAUE_TABLES_FAIL';